import Vue from "vue";

import App from "./shared/App";

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import Vuex from "vuex";
Vue.use(Vuex);

import lodash from "lodash";
Vue.use(lodash);

import VueNestable from 'vue-nestable'
Vue.use(VueNestable)

// var VueCookie = require('vue-cookie');
// Vue.use(VueCookie);
// var lang = "en"; // VueCookie.get("AdminLanguageCulture") || "en"

//languages
import vuexI18n from "vuex-i18n";

const i18nStore = new Vuex.Store();
Vue.use(vuexI18n.plugin, i18nStore);

import en from "./helpers/lang/en.json";
import fr from "./helpers/lang/fr.json";

// var lang = navigator.language || navigator.userLanguage;
var lang = "fr";
// Vue.i18n.set(lang.indexOf('en') >= 0 ? 'en' : 'fr');
Vue.i18n.set("fr");
// Vue.i18n.add('en', en);
Vue.i18n.add("fr", fr);
//

window.moment = require("moment");
moment.locale(lang);
Vue.use(require("vue-moment"));

Vue.config.productionTip = false;

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
Vue.component("datetime", Datetime);

import { Settings } from "luxon";
Settings.defaultLocale = lang;

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
Vue.component("vueDropzone", vue2Dropzone);

import Vuetable from "vuetable-2/src/components/Vuetable";
Vue.component("vuetable", Vuetable);

import VJstree from "vue-jstree";
Vue.component("v-jstree", VJstree);

import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
Vue.component("vuetable-pagination", VuetablePagination);

import VuePreventBack from "./Helpers/Plugins/directive";

Vue.use(VuePreventBack, {
  message:
    "Vous avez des changements non sauvegardés. Êtes-vous sûr de vouloir quitter cette page?"
});

import { SlickList, SlickItem } from 'vue-slicksort';
Vue.component("SlickList", SlickList);
Vue.component("SlickItem", SlickItem);
import router from "./router";

//register component globally
const requireComponent = require.context(
  "./components",
  true,
  /[a-z]\w+\.(vue)$/
);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  Vue.component(
    componentConfig.default.name,
    componentConfig.default || componentConfig
  );
});

import VolcanContent from "@s/content";
Vue.component(VolcanContent.name, VolcanContent);

import config from "./Helpers/Plugins/config.js";
Vue.use(config);

import language from "./Helpers/Plugins/languages.js";
Vue.use(language);

import menuItems from "./Helpers/Plugins/menuItems.js";
Vue.use(menuItems);

import logError from "./Helpers/Plugins/logError.js";
Vue.use(logError);

import parseEsTemplate from "./Helpers/Plugins/parseEsTemplate.js";
Vue.use(parseEsTemplate);

import compte from "./Helpers/Plugins/compte.js";
Vue.use(compte);

import loading from "./Helpers/Plugins/loading.js";
Vue.use(loading);

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB4HwWOXzzczUoAgiM0eob6nHOXZZ2j-xw",
    libraries: "places",
    language: "fr"
  }
});


var Inputmask = require("inputmask");

Vue.directive("input-mask", {
  bind: function(el) {
    new Inputmask().mask(el);
  }
});

import "@a/perfect-scrollbar/perfect-scrollbar.jquery.min.js";
import "@a/perfect-scrollbar/perfect-scrollbar.min.css";

window.App = new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>"
});



//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = null
// module chunks = 